import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/src/shadComponents/ui/button';
import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface DeviceRegistrationActionsProps {
    orgId: number;
    row: any;
    onDelete: () => void;
}

export default function DeviceRegistrationActions({
    orgId,
    row,
    onDelete,
}: DeviceRegistrationActionsProps) {
    const deviceRegistrationId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `${orgId}/device-registration-autoenroll/${deviceRegistrationId}`,
            );

            if (response.status === 204) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete device registration for "${row.original.deviceName}" (${row.original.deviceId})?`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };

    return (
        <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" onClick={performDelete}>
                <Trash2 className="size-4 text-destructive" />
            </Button>
        </div>
    );
}
